// extracted by mini-css-extract-plugin
module.exports = {"container":"MaterialsTypesTable_container__28tBN","tableContainer":"MaterialsTypesTable_tableContainer__1hXEq"};